import {
  type StoryblokAlgoliaCategorySearchFilterConditionType,
  type StoryblokAlgoliaCategorySearchFilterGroupType,
} from '../../storyblok'

type AlgoliaAttributes = {
  categoryCodes: string
  created: string
  discount: string
  nowProductGroup: string
  objectID: string
  prescriptionMedicine: string
  price: string
  promotionId: string
  promotionType: string
  redpointsEndDate: string
  redpointsMultiplier: string
  redpointsStartDate: string
  sellerId: string
  sellerPromotionType: string
  volumePricing: string
}

export const ALGOLIA_ATTRIBUTES: AlgoliaAttributes = {
  categoryCodes: 'categoryCodes',
  created: 'created',
  discount: 'discountInPercent',
  nowProductGroup: 'nowProductGroup',
  objectID: 'objectID',
  prescriptionMedicine: 'prescriptionMedicine',
  price: 'price',
  promotionId: 'best_offer.seller_promotion.promotionId',
  promotionType: 'best_offer.promotion.type',
  redpointsEndDate: 'RPEndDate',
  redpointsMultiplier: 'RPMultiplier',
  redpointsStartDate: 'RPStartDate',
  sellerId: 'best_offer.seller.id',
  sellerPromotionType: 'best_offer.seller_promotion.discountType',
  volumePricing: 'best_offer.volume_based_prices.quantity_threshold',
}

export type FilterNode =
  | StoryblokAlgoliaCategorySearchFilterConditionType
  | StoryblokAlgoliaCategorySearchFilterGroupType

export type OrGroupPack = {
  attribute: string
  operator?: ':' | '='
  values: string[]
} | null
